import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "why I don't sleep",
  "description": "",
  "published": "2012-06-09T00:00:00.000Z",
  "redirect_from": ["/blog/?p=4607"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`write about being mostly a night person, but a morning person for writing`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      